import { KubesoloStep } from '@api/types.gen';

import { Icon } from '@@/Icon';

import { stepLabels, stepStateIcons, stepStateLabels } from './steps';

/** A step's state as an icon, with the upload percentage while it runs. */
export function StepIcon({ step }: { step: KubesoloStep }) {
  const { icon, mode, spin } = stepStateIcons[step.state];
  const showProgress = step.state === 'running' && step.progress !== undefined;
  const label = stepStateLabels[step.state];

  return (
    <span
      className="inline-flex items-center gap-1 whitespace-nowrap"
      role="img"
      aria-label={`${stepLabels[step.name]}: ${label}`}
      title={label}
    >
      <Icon icon={icon} mode={mode} spin={spin} />
      {showProgress && <span className="small">{step.progress}%</span>}
    </span>
  );
}
